import SearchItem from './SearchItem'

export default function search(items: SearchItem[], query: string) {
  return items.filter((item) => item.matchesQuery(query))
}
